import { render, staticRenderFns } from "./ProjectModel.vue?vue&type=template&id=4df75921"
import script from "./ProjectModel.vue?vue&type=script&lang=ts"
export * from "./ProjectModel.vue?vue&type=script&lang=ts"
import style0 from "./ProjectModel.vue?vue&type=style&index=0&id=4df75921&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports